import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Color } from '../../core/types/color';
import { commonThemeBackgroundClass, commonThemeColorClass, getContrastColor } from '../../core/utilities/color';

@Component({
    selector: 'app-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class IconComponent {

  @Input() public faIcon?: IconProp;
  @Input() public bgColor?: Color;
  @Input() public color?: Color;
  @Input() public shape: 'circle' | 'square' = 'circle';
  @Input() public size: 'regular' | 'large' = 'regular';

  @HostBinding('class')
  protected get classes(): string {
    const effectiveBackgroundColor = this.bgColor ?? 'foreground';
    return [
      commonThemeBackgroundClass(effectiveBackgroundColor),
      commonThemeColorClass(this.color ?? getContrastColor(effectiveBackgroundColor)),
      this.shape,
      this.size,
    ].join(' ');
  }

}
